import React from 'react'

import style from '../../assets/styles/MainPage.module.css'

const MainPage = () => {

    return (

    <div className={ style.mainPage }>

        <header className={ style.bannerPrincipal } >
            <div className={ style.bannerTexto }>
                <h1>Roof Events</h1>
                <h2>Organiza tus Eventos </h2>
                <p>Agenda horarios, otorga constancias y más</p>
                {/* <button 
                    onClick={ () =>  history.push('/signup') }
                    className={ `btn activo bg-primary mt-1` }
                >
                    Unirse
                </button> */}
            </div>
            {/* <div className={ style.bannerImagen }>
                <img src={ imagenBanner } alt="" />
            </div> */}
            </header>
            {/* <main className={ style.roofSalesScreenMain }>
                <h3> Estas organizaciones ya confiaron en nosotros </h3>

                <ContenedorOrganizadores />

                

            </main> */}
    </div>
    )
}

export default MainPage
